import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { CustomerCoverageCandidateSearchResponse } from '@lio/api-types';
import { useClient } from '@utils/api-client';

export const useCustomerCoverageCandidate = (quoteId: string | undefined) => {
  const client = useClient();
  const result = useQuery({
    enabled: !!quoteId,
    placeholderData: keepPreviousData,
    queryKey: ['quoteId', { quoteId }],
    queryFn: () =>
      client.get(`quote/${quoteId}/customer-coverage-candidate`).json<CustomerCoverageCandidateSearchResponse>(),
    refetchOnWindowFocus: false,
  });

  return { ...result, duplicateQuotes: result?.data };
};
